export enum SurveyType {
    Waitlist
}